// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.
/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS207: Consider shorter variations of null checks
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
import {ModelDestroyOptions, ModelSetOptions} from 'backbone';

import * as analytics from 'analytics/Analytics';
import {
  Annotation as BioJSAnnotation,
  AnnotationCollection as BioJSAnnotationCollection,
} from 'biojs/Annotation';
import {Sequence} from 'components/Sequence';
import {ANALYTICS_MODULE} from 'constants/AnalyticsConstants';
import {CustomField, Strand} from 'constants/MolbioConstants';
import * as selectables from 'molbio/maps/selectables/Selectables';
import {trackClickOnAnnotationInSequence} from 'molbio/SequenceAnalyticsHelper';
import {Optional} from 'util/Types';

export interface AnnotationAttributes extends selectables.SelectableAttributes {
  id: number;
  visible: boolean;
  hover: boolean;
  annularLayer: number;
  _annotation: BioJSAnnotation;
  // Values of LayerMode enum
  fullLayer: number;
  inlineLayer: number;
  'inlineLayer-pdf': number;
}

interface Annotation {
  get<K extends keyof AnnotationAttributes>(key: K): AnnotationAttributes[K];
  set(obj: Partial<AnnotationAttributes>, options?: ModelSetOptions): Annotation;
  set<K extends keyof AnnotationAttributes>(
    key: K,
    value: AnnotationAttributes[K],
    options?: ModelSetOptions
  ): Annotation;
}

class Annotation extends selectables.RegionSelectable<Sequence> {
  defaults(): Partial<AnnotationAttributes> {
    return {
      ...super.defaults(),
      visible: true,
      hover: false,
    };
  }

  type(): string {
    return 'annotation';
  }

  initialize(): void {
    // eslint-disable-next-line @typescript-eslint/unbound-method
    this.listenTo(this.get('_annotation'), 'change', this.change);
    this.listenTo(
      this.get('_annotation'),
      'destroy remove',
      function (model: BioJSAnnotation, collection: BioJSAnnotationCollection, options: ModelDestroyOptions) {
        // @ts-expect-error: `this` shadowing
        return this.selfDestroy(options);
      }
    );
    // Hack, but sync this ID with the _annotation. This is needed because the Annotations collection sets
    // this ID upon add, but if the _annotation is added before being saved the ID needs to be fixed.
    this.listenTo(this.get('_annotation'), 'change:id', function () {
      // @ts-expect-error: `this` shadowing
      return this.set({id: this.get('_annotation').id});
    });
  }

  start(): number {
    return this.get('_annotation').start();
  }
  end(): number {
    return this.get('_annotation').end();
  }
  editable(): boolean {
    return this.get('_annotation').editable();
  }

  hover(): boolean {
    return this.get('hover');
  }
  color(): string {
    return this.get('_annotation').color();
  }
  name(): string {
    return this.get('_annotation').name();
  }
  notes(): string {
    return this.get('_annotation').notes();
  }
  customFields(): Array<CustomField> {
    return this.get('_annotation').customFields();
  }
  displayLabel(): string {
    return this.name();
  }
  annotationType(): string {
    return this.get('_annotation').get('annotation_type') ?? '';
  }
  uid(): string {
    return this.get('_annotation').cid;
  }
  strand(): Strand {
    return this.get('_annotation').strand();
  }
  annularLayer(): number {
    return this.get('annularLayer');
  }
  change(model: BioJSAnnotation, options: ModelSetOptions): void {
    return this.trigger('change:_annotation', this, this.collection, options);
  }

  visible(): boolean {
    return this.get('visible');
  }
  fromSubPart(): boolean {
    return this.get('_annotation').fromSubPart();
  }

  selfDestroy(options?: ModelDestroyOptions): JQueryXHR {
    if (options == null) {
      options = {};
    }
    return this.trigger('destroy', this, this.collection, options);
  }

  destroy(): JQueryXHR {
    const resp = this.get('_annotation').destroy();
    this.selfDestroy();
    return resp;
  }

  click(sequence: Sequence, shiftKey: Optional<boolean>): void {
    if (shiftKey == null) {
      shiftKey = false;
    }
    trackClickOnAnnotationInSequence(sequence, this.start(), this.end());
    const selection = sequence.get('selection');
    if (shiftKey) {
      // @ts-expect-error
      return selection.expandRange(this.start(), this.end());
    } else {
      // eslint-disable-next-line @typescript-eslint/no-confusing-void-expression
      return selection.select(this);
    }
  }

  dblClick(sequence: Sequence, shiftKey: Optional<boolean>): void {
    if (shiftKey == null) {
      shiftKey = false;
    }
    this.click(sequence, shiftKey);
    if (sequence.allowFeatureEdits() && this.editable()) {
      analytics.track('annotation', 'open_annotation_panel', {
        product: ANALYTICS_MODULE.MOLBIO,
        openedFrom: 'annotation_double_click',
        sequence_id: sequence.get('id'),
      });
      return sequence.get('selection').trigger('annotation', this);
    }
  }
}

export default Annotation;
